import './../../assets/less/pmi-detail.less';
import './../../common/common';
import $http from './../../common/http';
import {
  getRequest,
  getSdkAppIdByEvnNum,
  extendPrototype,
  beaconReport,
  execCommandCopy,
  divideNum,
  randomString,
  downloadApp,
  isMobile,
  isiPad,
  getQueryObject,
  getInstallState,
  isWeiXinGte656,
  filterXss,
} from './../../common/util';
import Toast from './../../components/Toast/Toast';
import {
  removeClass,
  addClass,
  loadScript,
  atou,
  getOsName,
  isFormalEnv,
  isAndroid,
  isIOS,
  isWeChat,
  isWxwork,
  makePhoneLink,
  loadVConsoleScript,
  isLinux,
  isSupportWebp,
  deleteURLSearch,
  isTestEnv,
} from './../../web-tools/utils/util';
import { getCalendarDescriptionForPmi, getICalendarDescPhoneInfo } from './../../web-tools/utils/iCalendar';
import { MEETING_STATE, SCHEME_URL } from './../../web-tools/utils/constant';
import { handleAvatar } from './../../web-tools/user-center/util';
import Dialog from '../../components/Dialog/Dialog';
import ChooseLangDialog from './../../components/ChooseLangDialog/ChooseLangDialog';
import { t } from '../../i18n';
import { telEntryDialogCopyBtnI18n, fillTelMeetingModalHtml, getUserPstn,
  showMiniProgramButton, showTelJoinEntry, getCurrentLanguage, getCurrentLangForCopy,
  getUserLangForReport, isWindowsWechatInSpecifiedVersion, getTapiPrefix, queryInviteContent } from './../../utils/util';
// import { JUMP_TYPE } from '../../common/constants';
import { initLaunch, launchApp } from './../../web-tools/utils/scheme';
import Common from './../../web-tools/model/data/common.ts';
import { addClassForElement, removeClassFromElement } from './../../common/controls-helper';
import { isOverseasByDomainName, downloadVooVMeeting, downloadTencentMeeting } from './../../utils/ip-tools';
import config from '../../config/index.ts';
import { renderI18nText } from './../../utils/renderDetail';
renderI18nText();

const IS_I18N = process.env.IS_I18N === 'true';
const DO_NOT_SUP_LINUX_TEXT = t('暂不支持linux系统');
const common = new Common();

extendPrototype();

const isLaunchingApp = () => {
  const meetingStateTextEl = document.getElementById('meetingStateTextCtrl');
  // 是否正在启动腾讯会议 is_launching_app (0 否；1 是)
  if (meetingStateTextEl) {
    return (meetingStateTextEl.innerText === `正在启动${config.APP_NAME}…` ? 1 : 0);
  }
  return 1;
};


const getHumanReadableDialText = (switchboard, extension) => {
  let ret = switchboard;
  if (typeof extension === 'string' && extension.length) {
    ret += t('转') + extension;
  }
  return ret;
};

/**
 * 微信下页面展示逻辑
 */
const enterPmiDetailPageInWxAgain = () => {
  getInstallState(isIOS() ? 'iphone' : '', '', !IS_I18N).then((res) => {
    if (res) {
      // 是否安装结果信息存在err_msg结构里
      const msg = res.err_msg || '';
      if (msg.indexOf('get_install_state:yes') >= 0) {
        window.pmiPageDetail.enterPageJoinMeeting();
      }
      if (msg.indexOf('get_install_state:no') >= 0) {
        window.pmiPageDownloadGuide.enterPageDownloadApp();
      }
    }
  });
};

/**
 * 微信下页面展示逻辑
 */
const enterPmiDetailPageInWx = () => {
  getInstallState(isIOS() ? 'iphone' : '', '', !!IS_I18N).then((res) => {
    if (res) {
      // 是否安装结果信息存在err_msg结构里
      const msg = res.err_msg || '';
      if (msg.indexOf('get_install_state:yes') >= 0) {
        window.pmiPageDetail.enterPageJoinMeeting();
      }
      if (msg.indexOf('get_install_state:no') >= 0) {
         // 检测两次，一个 app 不行的话再检测另外个 app，
        enterPmiDetailPageInWxAgain();
      }
    }
  });
};

const initLaunchRes = initLaunch();

window.$downloadContainer = {
  // 跳转到VooV Meeting下载链接
  downloadVooVMeeting,
  // 跳转到Tencent Meeting下载链接
  downloadTencentMeeting() {
    beaconReport('web_invitedpage_downloadpage_downloadlink_tencentmeeting_null_click', {});

    downloadTencentMeeting();
  },
};

window.pmiPageDownloadGuide = {
  url: '',
  password: '', // 目前没有使用
  // 0 - 还没开始; 1 - 已取消; 2 - 正在进行; 3 - 已结束; 4 - 即将开始; 5 - 已到预约时间; -1 - 会议不存在(自定义)
  meetingState: 0,
  meetingStateText: '',
  token: decodeURIComponent(getRequest('mtoken') || getRequest('token')),
  envTest: Number(getRequest('envtest') || 0),
  launchId: null,
  resData: {}, // queryMeetingSimpleInfo() 返回的数据
  qrcodeDialogEl: document.getElementById('qrcodeDialogCtrl'),

  gotoBack() {
    history.go(-1);
  },

  gotoDownload() {
    // 用户访问了 “国内域名”
    if (isOverseasByDomainName() === 'no') {
      // 用户在 国外(ip= 港澳台+海外)
      if (window.pmiPageDetail.ipLocation.countryCodes !== 'cn') {
        // 下载VooV Meeting
        downloadVooVMeeting();
      } else {
        downloadTencentMeeting();
      }
    } else { // 用户访问了 “国外VooV域名”
      // 用户在国内(ip=大陆)
      if (window.pmiPageDetail.ipLocation.countryCodes === 'cn') {
        // 下载腾讯会议
        downloadTencentMeeting();
      } else {
        downloadVooVMeeting();
      }
    }
  },

  /**
 * @param {*} type
 * @param {*} meetingCode
 */
  getSchemaUrl(type, meetingCode) {
    let schemeUrl = `${config.SCHEME_URL.INMEETING}?meeting_code=${meetingCode}&launch_id=${this.launchId}&is_pmi=1`;
    console.log(schemeUrl);
    if (type === 'launchApp') {
      schemeUrl = SCHEME_URL.LAUNCH;
    }
    return schemeUrl;
  },
  /**
   * 启动腾讯会议
   * @returns {Promise<boolean>}
   */
  async onClickLaunchApp(type = 'meetingCode') {
    console.log('>>> onClickLaunchApp:', this.meetingState);
    this.launchId = randomString(16);
    // 是否是voov
    const isVoov = IS_I18N;
    const launchParams = {
      initLaunchRes,
      isVoov,
      schemaUrl: this.getSchemaUrl(type, window.pmiPageDetail.resData.pmi_code),
      launchId: this.launchId,
      page: 'pmi-detail',
      defaultLogic: {
        fail: () => {
          document.getElementById('wxwork-open-browser-guide').style.display = 'block';
        },
        jumpCallback: (response) => {
          if (response && response.msg) { // 当前微信版本较低
            Dialog({
              show: true,
              title: response.msg.title,
              content: response.msg.content,
              confirmFn: () => {
                console.log('>>> Dialog confirmFn:');
                execCommandCopy(this.url);
                Toast(t('会议链接已复制到剪切板'));
              },
            });
          }
        },
        reportCallback: beaconReport,
      },
      launchCallback: {
        success: (startTime) => {
          const currentTime = new Date();
          beaconReport('launch_app_succ', {
            sense_time: Math.floor((currentTime - startTime) / 1000),
            meeting_code: this.meetingCode,
            meeting_state: this.meetingState,
            user_agent: navigator.userAgent,
            is_launching_app: isLaunchingApp(),
            is_pmi: 1, // 是否是PMI会议，1：是
            launch_from: 3, // 3：PMI会议
          });
          window.pmiPageDetail.goToConferenceDetail();
        },
        fail: (startTime) => {
          const currentTime = new Date();
          beaconReport('launch_app_fail', {
            time_past: Math.floor((currentTime - startTime) / 1000),
            meeting_code: this.meetingCode,
            meeting_state: this.meetingState,
            user_agent: navigator.userAgent,
            is_launching_app: isLaunchingApp(),
            is_pmi: 1, // 是否是PMI会议，1：是
            launch_from: 3, // 3：PMI会议
          });
        },
      },
      handleVoovJumpMeetingDetailPage: window.pmiPageDetail.handleVoovJumpMeetingDetailPage,
    };
    launchApp(launchParams);
  },

  /**
   * 详情部分启动腾讯会议灯塔上报事件
   */
  beaconReportClickJoinButtonOnDetail() {
    beaconReport('click_join_button_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      // is_launching_app: isLaunchingApp(),
      is_launching_app: 1,
      is_pmi: 1, // 是否是PMI会议，1：是
    });
  },

  /**
   * 唤起部分启动腾通讯会议灯塔上报事件
   */
  beaconReportWebLaunchLinkClick() {
    beaconReport('web_launch_link_click', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      is_pmi: 1, // 是否是PMI会议，1：是
    });
  },

  /**
   * 详情部分启动腾讯会议
   */
  onClickLaunchAppOnButton(type) {
    if (isLinux()) {
      Toast(DO_NOT_SUP_LINUX_TEXT);
      return false;
    }
    window.pmiPageDownloadGuide.beaconReportClickJoinButtonOnDetail();
    window.pmiPageDownloadGuide.onClickLaunchApp(type);
  },

  /**
   * 唤起部分启动腾讯会议
   */
  onClickLaunchAppOnLink() {
    if (isLinux()) {
      Toast(DO_NOT_SUP_LINUX_TEXT);
      return false;
    }
    window.pmiPageDownloadGuide.beaconReportWebLaunchLinkClick();
    window.pmiPageDownloadGuide.onClickLaunchApp();
  },
  /**
   * PC和移动端唤醒页面显示不同的提示文案
   */
  setTextByDeviceType() {
    if (isMobile()) {
      document.getElementById('mobile-device').style.display = 'block';
      document.getElementById('pc-device').style.display = 'none';
    } else {
      document.getElementById('pc-device').style.display = 'block';
      document.getElementById('mobile-device').style.display = 'none';
    }
  },
  /**
   * 微信进入页面拉起下载
   * @param {*} type
   */
  enterPageDownloadApp() {
    window.pmiPageDetail.hideWxDetailPage();
    this.showWxDownloadPage();
    // ios下自动唤起下载提示
    if (isIOS()) {
      window.pmiPageDownloadGuide.gotoDownload();
    }
  },

  /**
   * 展示下载页
   */
  showWxDownloadPage() {
    this.showWxDownloadContainer();
    window.pmiPageDownloadGuide.setTextByDeviceType();
  },

  /**
   * 展示下载页界面
   */
  showWxDownloadContainer() {
    const launchAppContainerEl = document.getElementById('launch-app-container');
    if (launchAppContainerEl) {
      launchAppContainerEl.style.display = 'block';
    }
  },
  /**
   * 隐藏下载页界面
   */
  hideWxDownloadContainer() {
    const launchAppContainerEl = document.getElementById('launch-app-container');
    if (launchAppContainerEl) {
      launchAppContainerEl.style.display = 'none';
    }
  },
};

const qrcodeImg = {
  el: document.getElementById('qrcodeImgCtrl'),
  startX: 0,
  endX: 0,
  startY: 0,
  endY: 0,
  rect: [],
  startTime: 0,
  endTime: 0,

  handleTouchstart(e) {
    // e.preventDefault(); // 这里会导致安卓长按二维码没有反应
    qrcodeImg.startTime = (new Date()).getTime();
    qrcodeImg.startX = e.touches[0].clientX;
    qrcodeImg.startY = e.touches[0].clientY;
    console.log('>>> handleTouchstart:', e, '\n', qrcodeImg.startX, qrcodeImg.startY);
  },
  handleTouchend(e) {
    e.preventDefault();
    qrcodeImg.endTime = (new Date()).getTime();
    qrcodeImg.endX = e.changedTouches[0].clientX;
    qrcodeImg.endY = e.changedTouches[0].clientY;
    console.log('>>> handleTouchend:', e, '\n', qrcodeImg.endX, qrcodeImg.endY);
    qrcodeImg.dealTime();
  },
  handleTouchmove(e) {
    e.preventDefault();
    console.log('>>> handleTouchmove:', e);
  },
  initRect(e) {
    console.log('>>> initRect:', e.x, e.y, e.width, e.height);
    const leftTopDot = [e.x, e.y - e.height / 2]; // transform: translateY(-50%); 使坐标有变化, 需要减 e.height / 2;
    const rightTopDot = [leftTopDot[0] + e.width, leftTopDot[1]];
    const leftBottomDot = [leftTopDot[0], leftTopDot[1] + e.height];
    const rightBottomDot = [leftTopDot[0] + e.width, leftTopDot[1] + e.height];
    qrcodeImg.rect.push(leftTopDot);
    qrcodeImg.rect.push(rightTopDot);
    qrcodeImg.rect.push(leftBottomDot);
    qrcodeImg.rect.push(rightBottomDot);
    console.log(qrcodeImg.rect);
  },
  calculateRect() {
  },
  handleMousedown(e) {
    e.preventDefault();
    console.log('>>> handleMousedown:', e);
    qrcodeImg.startTime = (new Date()).getTime();
    if (window.pmiPageDetail && window.pmiPageDetail.qrcodeDialogEl) {
      window.pmiPageDetail.qrcodeDialogEl.style.display = 'block';
    }
  },
  handleMouseup(e) {
    e.preventDefault();
    console.log('>>> handleMouseup:', e);
    qrcodeImg.endTime = (new Date()).getTime();
    qrcodeImg.dealTime();
  },
  dealTime() {
    console.log(qrcodeImg.startTime, qrcodeImg.endTime, qrcodeImg.endTime - qrcodeImg.startTime);
    if ((qrcodeImg.endTime - qrcodeImg.startTime) > 1 * 1000) {
      console.log('>>> 长按超过 1s');
      window.pmiPageDetail.mouseOnQrCode();
    }
  },
};

window.pmiPageDetail = {
  url: '',
  password: '', // 目前没有使用
  // 0 - 还没开始; 1 - 已取消; 2 - 正在进行; 3 - 已结束; 4 - 即将开始; 5 - 已到预约时间; -1 - 会议不存在(自定义)
  meetingState: 0,
  meetingStateText: '',
  token: decodeURIComponent(getRequest('token')),
  meetingCode: getRequest('meetingcode'),
  envTest: Number(getRequest('envtest') || 0),
  launchId: null,
  resData: {}, // queryMeetingSimpleInfo() 返回的数据
  defaultAreaInfo: {}, // getAppCommonConfig() 返回的数据
  qrcodeDialogEl: document.getElementById('qrcodeDialogCtrl'),
  isPmi: getRequest('is_pmi'), // 是否是PMI会议
  pmiCode: getRequest('pmi_code'), // PMI会议号
  telEntryDialogCopyBtnI18n,
  fillTelMeetingModalHtml,
  getUserPstn,
  copyMeetingInfo: '',
  joinMode: Number(getRequest('mode') || 0), // 加入会议模式
  ipLocation: {
    countryCodes: '', // 国家地区二字码: 'cn'\
  },

  // 判断是否支持webp图片格式
  ifSupportWebp() {
    if (isSupportWebp()) {
      addClassForElement('appCtrl', 'support-webp-container');
    } else {
      removeClassFromElement('appCtrl', 'support-webp-container');
    }
  },

  setDefLanguage() {
    const langEl = document.getElementById('language-text');
    if (langEl) {
      langEl.innerText = getCurrentLanguage();
    }
  },

  // 根据IP地址获取对应地区
  getIpLocation() {
    const ip = getRequest('location_info') || '';
    return common.ipLocation({
      ip, // 如果不传则取来源IP进行判断
    })
      .then((res) => {
        console.log('>>> ipLocation res:', res);
        if (
          res && res.code === 0
          && res.data
        ) {
          this.ipLocation.countryCodes = res.data.country_codes || 'cn';
        } else {
          // 兜底逻辑，接口报错时设置为 国内
          this.ipLocation.countryCodes = 'cn';
        }

        // 处理 “唤起腾讯会议 APP 页面” 的文案
        this.handleLaunchAppPage(this.ipLocation.countryCodes);
      })
      .catch((err) => {
        console.error(err);
        // 兜底逻辑，接口报错时设置为 国内
        this.ipLocation.countryCodes = 'cn';
        // 处理 “唤起腾讯会议 APP 页面” 的文案
        this.handleLaunchAppPage(this.ipLocation.countryCodes);
      });
  },
  // 处理 “唤起腾讯会议 APP 页面” 的文案
  handleLaunchAppPage(countryCodes) {
    // "立即下载按钮"
    const joinBtnCtrlLanuchEl = document.getElementById('joinBtnCtrlLanuch');
    const voovDownloadContainerEl = document.querySelector('.voov-download-container');
    const tencentDownloadContainerEl = document.querySelector('.tencent-download-container');
    if (
      !joinBtnCtrlLanuchEl
      || !voovDownloadContainerEl
      || !tencentDownloadContainerEl
    ) {
      console.error('页面结构异常');
      return false;
    }

    // 私有化版本: 隐藏下载按钮 及 不显示提示文案
    if (process.env.WEMEET_PARAM_PRIVATE) {
      joinBtnCtrlLanuchEl.style.display = 'none';
      voovDownloadContainerEl.style.display = 'none';
      tencentDownloadContainerEl.style.display = 'none';
      // 1: 首句文案
      const tencentMeetingDescFirstTxtEl = document.getElementById('tencentMeetingDescFirstTxt');
      if (tencentMeetingDescFirstTxtEl) {
        tencentMeetingDescFirstTxtEl.innerHTML = t('若无法正常跳转请先下载客户端');
      }
      return false;
    }
    // 是否是 voov 借用 meeting 域名做拉起情况
    const queryObj = getQueryObject();
    const isSubpage = queryObj.subpage === 'launch';

    // 默认不显示: 在 js 中控制显隐
    if (!IS_I18N) {
      voovDownloadContainerEl.style.display = 'block';
    } else {
      tencentDownloadContainerEl.style.display = 'block';
    }

    // 用户访问了 “国内域名” 并且不是 voov 借用情况下
    if (isOverseasByDomainName() === 'no' && !isSubpage) {
      // 用户在 国外(ip= 港澳台+海外)
      if (countryCodes !== 'cn') {
        // 1: 首句文案
        const tencentMeetingDescFirstTxtEl = document.getElementById('tencentMeetingDescFirstTxt');
        if (tencentMeetingDescFirstTxtEl) {
          tencentMeetingDescFirstTxtEl.innerHTML = t('若无法正常跳转请先点击下方按钮或链接进行下载');
        }
        // 2: 按钮文案
        joinBtnCtrlLanuchEl.innerHTML = t('下载 VooV Meeting Button');
        // 3: 提示
        tencentDownloadContainerEl.style.display = 'block';
        voovDownloadContainerEl.style.display = 'none';
      }
    } else { // 用户访问了 “国外VooV域名”
      // 用户在国内(ip=大陆)
      if (countryCodes === 'cn') {
        // 2: 按钮文案
        joinBtnCtrlLanuchEl.innerHTML = IS_I18N ? t('下载 腾讯会议 Button') :  t('下载 {{appname}}', {
          appname: config.APP_NAME,
        });
        // 3: 提示
        tencentDownloadContainerEl.style.display = 'none';
        voovDownloadContainerEl.style.display = 'block';
      }
    }
  },

  /**
   * 是否展示pmi tips
   */
  ifShowInfoTips(ifShow = false) {
    const infoTipsElement = document.getElementById('tm-pmi-code-info-container');
    if (infoTipsElement) {
      if (ifShow) {
        infoTipsElement.style.display = 'block';
      } else {
        infoTipsElement.style.display = 'none';
      }
    }
  },
  chooseLang() {
    ChooseLangDialog.show({
      closeFn: () => {
        const arrowEl = document.getElementById('language-arrow');
        if (arrowEl) {
          arrowEl.className = 'language-arrow-down';
        }
      },
    });
    const arrowEl = document.getElementById('language-arrow');
    if (arrowEl) {
      arrowEl.className = 'language-arrow-up';
    }
  },
  /**
   *移动端点击显示指引框
   */
  showInfoDialog() {
    if (isMobile) {
      this.ifShowInfoTips(true);
    }
  },
  /**
   * 点击其余区域隐藏指引框
   */
  handleClickOutside(e) {
    const infoIconElement = document.getElementById('info-icon');
    const infoContainerElement = document.getElementById('tm-pmi-code-info-container');
    if (
      infoIconElement
      && infoContainerElement
      && !infoIconElement.contains(e.target)
      && !infoContainerElement.contains(e.target)
    ) {
      infoContainerElement.style.display = 'none';
    }
  },
  /**
   * 初始化pmi会议号指引相关
   */
  initPmiInfoDirection() {
    if (!localStorage.getItem('ifFirstOpenPmi')) {
      localStorage.setItem('ifFirstOpenPmi', true);
    }
    window.pmiPageDetail.ifShowInfoTips(true);
    if (localStorage.getItem('ifFirstOpenPmi') === 'true') {
      setTimeout(window.pmiPageDetail.ifShowInfoTips, 5000);
    } else {
      window.pmiPageDetail.ifShowInfoTips(false);
    }
    localStorage.setItem('ifFirstOpenPmi', false);
    document.addEventListener('mousedown', (e) => {
      window.pmiPageDetail.handleClickOutside(e);
    });
  },
  downloadAppFn() {
    beaconReport('download_app_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      is_launching_app: isLaunchingApp(),
      is_pmi: 1, // 是否是PMI会议，1：是
    });
    if (isAndroid()) {
      location.href = './mobile/downloadindex.html';
    } else if (isIOS()) {
      if (isWxwork()) { // 企业微信打不开 appstore 链接
        document.getElementById('android-download-guide').style.display = '';
      } else {
        location.href = 'https://itunes.apple.com/cn/app/id1484048379';
      }
    } else {
      downloadApp();
    }
  },
  formatPstnPhone(pstnPhone) {
    let res = '';
    const tmp = pstnPhone.split('-');
    for (let i = 0; i < tmp.length; i++) {
      if (i === 0) { // 第一个
        res = res + String(Number(tmp[i])); // 去除首位的 0
      } else if (i === (tmp.length - 1)) { // 最后一个
        res = `${res},${tmp[i]}`;
      } else {
        res = `${res}-${tmp[i]}`;
      }
    }
    return res;
  },
  getPhoneUri() {
    let dialObj;
    if (navigator.appVersion.includes('Android')) {
      if (typeof this.resData.android_one_dial !== 'object') {
        Toast(t('未获取到拨号信息'));
        return false;
      }
      dialObj = this.resData.android_one_dial;
    } else {
      if (typeof this.resData.ios_one_dial !== 'object') {
        Toast(t('未获取到拨号信息'));
        return false;
      }
      dialObj = this.resData.ios_one_dial;
    }
    return `tel:${makePhoneLink(dialObj, dialObj.default_area, this.meetingCode, this.password)}`;
  },
  onClickWeChatButton() {
    if (isMobile() && !isiPad()) {
      const qrcodeDialogCtrl2El = document.getElementById('qrcodeDialogCtrl2');
      if (qrcodeDialogCtrl2El) {
        qrcodeDialogCtrl2El.style.display = 'block';
      }
    } else { // pc
      if (window.pmiPageDetail && window.pmiPageDetail.qrcodeDialogEl) {
        window.pmiPageDetail.qrcodeDialogEl.style.display = 'block';
      }
    }
  },
  clickCopyNumBtn() {
    beaconReport('copy_meeting_phone_info_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      is_launching_app: isLaunchingApp(),
      is_pmi: 1, // 是否是PMI会议，1：是
    });
    const phoneInfo = getICalendarDescPhoneInfo({
      summary: atou(this.resData.subject),
      url: atou(this.resData.url),
      location: atou(this.resData.location),
      startDate: new Date(this.resData.begin_time * 1000),
      endDate: new Date(this.resData.end_time * 1000),
      meetingCode: this.resData.meeting_code,
      password: atou(this.resData.password),
      pstnPhone: String(this.resData.pstn_phone).replace(/\s*/g, ''),
      oneDial: isIOS() ? this.resData.ios_one_dial : this.resData.android_one_dial,

      hostAppUid: this.resData.host_app_uid || [],
      inviteList: this.resData.invite_list || [],
      creatorAppUid: '',
      nickName: '',
      userType: this.resData.creator_user_type,
    });
    execCommandCopy(phoneInfo);
    Toast(t('号码复制成功'));
  },
  telEntryDialogCopyBtn(idx) {
    let dialObj = {};
    if (isIOS()) {
      dialObj = this.resData.ios_one_dial || {};
    } else {
      dialObj = this.resData.android_one_dial || {};
    }
    // 默认地区
    const defaultAreaInfo = dialObj[dialObj.default_area] || {};
    // 中国香港
    const hongkongChinaInfo = dialObj.hongkong_china || {};
    // 美国
    const usaInfo = dialObj.usa || {};
    switch (idx) {
      case 1: // 默认地区
        execCommandCopy(getHumanReadableDialText(defaultAreaInfo.switchboard, defaultAreaInfo.extension));
        Toast(t('电话号码已复制到剪切板'));
        break;
      case 2: // 中国香港
        execCommandCopy(getHumanReadableDialText(hongkongChinaInfo.switchboard, hongkongChinaInfo.extension));
        Toast(t('电话号码已复制到剪切板'));
        break;
      case 3: // 美国
        execCommandCopy(getHumanReadableDialText(usaInfo.switchboard, usaInfo.extension));
        Toast(t('电话号码已复制到剪切板'));
        break;
      case 4: // 默认地区
        window.location.href = `tel:${makePhoneLink(dialObj, dialObj.default_area, this.pmiCode, '')}`;
        break;
      case 5: // 中国香港
        window.location.href = `tel:${makePhoneLink(dialObj, 'hongkong_china', this.pmiCode, '')}`;
        break;
      case 6: // 美国
        window.location.href = `tel:${makePhoneLink(dialObj, 'usa', this.pmiCode, '')}`;
        break;
      default:
        console.log('>>> default');
    }
  },

  showTelJoinWrap() {
    let dialObj = {};
    if (isIOS()) {
      dialObj = this.resData.ios_one_dial || {};
    } else {
      dialObj = this.resData.android_one_dial || {};
    }

    dialObj.pstns.forEach((pstn) => {
      const { location } = pstn;
      dialObj[location] = pstn;
    });

    if (JSON.stringify(dialObj) === '{}' || JSON.stringify(dialObj) === '[]') {
      return;
    }

    showTelJoinEntry(!this.resData.media_set_type || this.resData.media_set_type === 0, this.meetingState);

    if (!IS_I18N) {
      this.dealTelEntryDialog(dialObj);
    }
  },

  // 充填 “电话入会” 号码
  dealTelEntryDialog(dialObj) {
    // 默认地区
    const defaultAreaInfo = dialObj[dialObj.default_area] || {};
    if (defaultAreaInfo.switchboard) {
      const defaultAreaEl = document.getElementById('defaultArea');
      defaultAreaEl.style.display = 'flex';
      defaultAreaEl.querySelector('.item-phone-num').innerText = getHumanReadableDialText(defaultAreaInfo.switchboard, defaultAreaInfo.extension);
      // 移动端
      const mDefaultAreaEl = document.getElementById('mDefaultArea');
      mDefaultAreaEl.style.display = 'flex';
      mDefaultAreaEl.querySelector('.item-phone-num').innerText = decodeURIComponent(makePhoneLink(dialObj, dialObj.default_area, this.pmiCode, ''));
    }
    // 中国香港
    const hongkongChinaInfo = dialObj.hongkong_china || {};
    if (hongkongChinaInfo.switchboard) {
      const hongkongChinaEl = document.getElementById('hongkongChina');
      hongkongChinaEl.style.display = 'flex';
      hongkongChinaEl.querySelector('.item-phone-num').innerText = getHumanReadableDialText(hongkongChinaInfo.switchboard, hongkongChinaInfo.extension);
      // 移动端
      const mHongkongChinaEl = document.getElementById('mHongkongChina');
      mHongkongChinaEl.style.display = 'flex';
      mHongkongChinaEl.querySelector('.item-phone-num').innerText = decodeURIComponent(makePhoneLink(dialObj, 'hongkong_china', this.pmiCode, ''));
    }
    // 美国
    const usaInfo = dialObj.usa || {};
    // console.log()
    if (usaInfo.switchboard) {
      const usaEl = document.getElementById('usa');
      usaEl.style.display = 'flex';
      usaEl.querySelector('.item-phone-num').innerText = getHumanReadableDialText(usaInfo.switchboard, usaInfo.extension);
      // 移动端
      const mUsaEl = document.getElementById('mUsa');
      mUsaEl.style.display = 'flex';
      mUsaEl.querySelector('.item-phone-num').innerText = decodeURIComponent(makePhoneLink(dialObj, 'usa', this.pmiCode, ''));
      // mUsaEl.querySelector('.item-phone-num').innerText = `${usaInfo.switchboard}-${this.meetingCode}`;
    }
  },
  onClickTelJoinButton() {
    beaconReport('click_tel_join_button_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      is_launching_app: isLaunchingApp(),
      // 是否移动端（is_mobile，整数类型，1为移动端，0为桌面端）
      is_mobile: (isMobile() ? 1 : 0),
      is_pmi: 1, // 是否是PMI会议，1：是
    });
    if (!isMobile() || isiPad()) { // PC 端
      console.log('>>> PC 端:');
      const telEntryDialogCtrlEl = document.getElementById('telEntryDialogCtrl');
      if (telEntryDialogCtrlEl) {
        telEntryDialogCtrlEl.style.display = 'block';
      }
    } else { // 移动端
      const mQrcodeDialogEl = document.getElementById('mQrcodeDialog');
      if (mQrcodeDialogEl) {
        mQrcodeDialogEl.style.display = 'block';
      }
    }
  },

  mouseOnQrCode() {
    beaconReport('mouse_on_qr_code_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      is_launching_app: isLaunchingApp(),
      is_pmi: 1, // 是否是PMI会议，1：是
    });
  },

  /**
   * 提前获取需要复制的会议信息，异步情况下无法直接复制
   */
  async preGetCopyMeetingInfo() {
    const params = {
      meetingId: this.resData.meeting_id,
      isSharePage: 1,
      language: getCurrentLangForCopy(),
      pmiCode: this.pmiCode,
    };
    if (this.resData.media_set_type === 1) {
      params.ability = 11;
    }
    let desc = await queryInviteContent(params).catch((err) => {
      console.log('>>> queryInviteContent err:', err);
    });
    console.log('>>> queryInviteContent:', desc);
    if (desc && desc.code === 0 && desc.invite_content) {
      desc = atou(desc.invite_content);
      console.log('>>> queryInviteContent success:');
    } else {
      desc = getCalendarDescriptionForPmi({
        url: atou(this.resData.url),
        meetingCode: this.resData.meeting_code,
        pmiCode: this.resData.pmi_code,
        pstnPhone: String(this.resData.pstn_phone).replace(/\s*/g, ''),
        oneDial: isIOS() ? this.resData.ios_one_dial : this.resData.android_one_dial,
        password: this.resData.password,
        hostAppUid: this.resData.host_app_uid || [],
        creatorAppUid: '',
        nickName: '',
        userType: this.resData.creator_user_type,
        userPstnInfo: this.userPstnInfo,
      }, t);
      console.log('>>> getCalendarDescriptionForPmi:', desc);
    }
    this.copyMeetingInfo = desc;
  },

  async clickCopyMeetingUrl() {
    console.log('>>> resData:', this.resData);
    beaconReport('copy_meeting_invitation_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      is_launching_app: isLaunchingApp(),
      is_pmi: 1, // 是否是PMI会议，1：是
    });
    execCommandCopy(this.copyMeetingInfo);
    Toast(t('会议邀请已复制到剪切板'));
  },

  clickCopyMeetingCode() {
    execCommandCopy(this.pmiCode);
    Toast(t('<span>会议号码已复制到剪切板 </br>(仅1.3.5及以上版本才可加入该会议)</span>'));
    beaconReport('click_copy_meeting_code_on_detail_page', {
      meeting_code: this.meetingCode,
      meeting_state: this.meetingState,
      user_agent: navigator.userAgent,
      is_launching_app: isLaunchingApp(),
      is_pmi: 1, // 是否是PMI会议，1：是
    });
  },
  /**
   * 点击加入会议
   */
  async onClickJoinMeetingButton(type = 'meetingCode') {
    // 微信新版本的兼容问题，显示蒙层
    const $tmp = isWindowsWechatInSpecifiedVersion();
    if ($tmp) {
      // document.getElementById('android-download-guide').style.display = '';
      window.pmiPageDetail.handleWindowsWechat(true);
      return false;
    }

    if (isLinux()) {
      Toast(DO_NOT_SUP_LINUX_TEXT);
      return false;
    }
    // voov 转发到会议df目录
    const isMeetingDf = IS_I18N && isOverseasByDomainName() === 'no'; 
    // 只在会议时候才判断，voov 走另外的逻辑
    if (isMeetingDf && isWeiXinGte656()) {
      window.pmiPageDownloadGuide.hideWxDownloadContainer();
    }
    if ((!IS_I18N || isMeetingDf)&& isMobile() && isWeChat()) {
      enterPmiDetailPageInWx();
      return false;
    }
    // 用户还没有查询到用户的 ip 地址对应的地区,则阻塞去查询结果: 不跳转到 “唤起腾讯会议 APP 页面”，但是会执行 schema 协议
    if (!this.ipLocation.countryCodes) {
      await this.getIpLocation();
    }

    // 显示 “唤起腾讯会议 APP 页面”
    document.getElementById('detail-container').style.display = 'none';
    // 访问海外时候隐藏，由subpage 转到国内域名再拉起
    if (IS_I18N && isOverseasByDomainName() === 'yes' && isWeiXinGte656()) {
      window.pmiPageDownloadGuide.hideWxDownloadContainer();
    } else {
      window.pmiPageDownloadGuide.showWxDownloadContainer();
    }
    window.pmiPageDownloadGuide.onClickLaunchAppOnButton(type);
    window.pmiPageDownloadGuide.setTextByDeviceType();
  },
  /**
   * 微信进入页面直接加入会议
   * @param {*} type
   */
  enterPageJoinMeeting(type = 'meetingCode') {
    window.pmiPageDownloadGuide.onClickLaunchAppOnButton(type);
  },

  handleVoovJumpMeetingDetailPage() {
    const tencentMeetingDescFirstTxtEl = window.pmiPageDetail.getElement('i18n-tencentMeetingDescFirstTxt');
    if (tencentMeetingDescFirstTxtEl) {
      tencentMeetingDescFirstTxtEl.innerHTML = t('若无法正常跳转，请先点击右上角 ... 选择用浏览器打开。或<span class="link" onclick="pmiPageDetail.goToConferenceDetail()">返回会议详情</span>使用其他方式加入会议。')
    }

    const mobilDeviceEl = window.pmiPageDetail.getElement('mobile-device');
    window.pmiPageDetail.hideElement(mobilDeviceEl);

    const pcDeviceEl = window.pmiPageDetail.getElement('pc-device');
    window.pmiPageDetail.hideElement(pcDeviceEl);

    const weDownloadBtnEl = window.pmiPageDetail.getElement('we-download-btn');
    window.pmiPageDetail.hideElement(weDownloadBtnEl);

    const voovDownloadContainerEl = window.pmiPageDetail.getElement('voov-download-container');
    window.pmiPageDetail.hideElement(voovDownloadContainerEl);

    const tencentDownloadContainerEl = window.pmiPageDetail.getElement('tencent-download-container');
    window.pmiPageDetail.hideElement(tencentDownloadContainerEl);
  },

  getElement(id) {
    const el = document.getElementById(id);
    return el;
  },

  hideElement(el) {
    if (el) {
      el.style.display = 'none';
    }
  },

  /**
   * 隐藏会议详情
   */
  hideWxDetailPage() {
    // document.getElementById('detail-container').style.height = 0;
    // document.getElementById('detail-container').style.visibility = 'hidden';
    const detailContainerEl = document.getElementById('detail-container'); 
    if (detailContainerEl) {
      detailContainerEl.style.display = 'none';
    }
  },
  /**
   * 微信下展示会议详情
   */
  // showWxDetailPage() {
  //   document.getElementById('detail-container').style.height = '100%';
  //   document.getElementById('detail-container').style.visibility = 'visible';
  // },
  /**
   * 返回会议详情
   */
  goToConferenceDetail() {
    const isUnVoovEnv = !location.origin.includes('voovmeeting.com');
    if (IS_I18N && isUnVoovEnv && isWeiXinGte656()) {
      console.log('微信内置浏览器 go back');
      const searchValue = deleteURLSearch(window.location.search, 'subpage')
      if (isTestEnv()) {
        location.href = `https://test.web.voovmeeting.com/df/en/pmi-detail.html${filterXss(searchValue)}`;
      } else {
        location.href = `https://voovmeeting.com/df/en/pmi-detail.html${filterXss(searchValue)}`;
      }
    } else {
      document.getElementById('detail-container').style.display = 'block';
      document.getElementById('launch-app-container').style.display = 'none';
      window.history.replaceState(
        { url: window.location.href },
        document.title,
        deleteURLSearch(window.location.href, 'subpage')
      );
    }
  },
  closePageLoading() {
    document.getElementById('docLoadingCtrl').style.display = 'none';
    document.getElementById('appCtrl').style.display = 'block';
  },
  setMeetingStateText(txt, textClass) {
    const meetingStateTextEl = document.getElementById('meetingStateTextCtrl');
    const meetingStateContainer = document.getElementById('pmi-meeting-state-container');
    addClass(meetingStateTextEl, textClass);
    addClass(meetingStateContainer, textClass);
    this.meetingStateText = txt;
    meetingStateTextEl.innerText = txt;
    document.getElementById('msgWrapTxtCtrl').innerText = txt;
  },
  startUp(txt) {
    const meetingStateTextEl = document.getElementById('meetingStateTextCtrl');
    removeClass(meetingStateTextEl, 'orange-color');
    this.meetingStateText = txt;
    meetingStateTextEl.innerText = txt;
  },
  /**
   *  已取消——”会议已取消“
   已删除——”会议已结束“（结束的快速会议，后台返回的是deleted）
   已回收——”会议号无效“
   会议不存在——”会议号无效“
   */
  showMsgWrap(show) {
    if (show) {
      document.getElementById('tm-meeting-info-container').style.display = 'none';
      document.getElementById('footCtrl').style.display = 'none';
      document.getElementById('meetingStateTextCtrl').style.display = 'none'; // 隐藏 title 的 tips
      document.getElementById('tm-pmi-meeting-info-and-join-meeting-container').style.display = 'none';
      document.getElementById('msgWrapCtrl').style.display = 'block';
    } else {
      document.getElementById('tm-meeting-info-container').style.display = 'flex';
      document.getElementById('footCtrl').style.display = 'flex';
      document.getElementById('meetingStateTextCtrl').style.display = 'block'; // 显示 title 的 tips
      document.getElementById('tm-pmi-meeting-info-and-join-meeting-container').style.display = 'block';
      document.getElementById('msgWrapCtrl').style.display = 'none';
    }
    document.getElementById('tm-header').style.display = 'flex';
  },
  dealMeetingState(state) {
    switch (state) {
      case MEETING_STATE.READY: // 待开始 0
        this.showMsgWrap(false);
        break;
      case MEETING_STATE.ACTIVE: // 进行中 2
        this.showMsgWrap(false);
        this.setMeetingStateText(t('进行中'), 'pmi-meeting-ing');
        break;
      case MEETING_STATE.CANCELED: // 已取消 1
        this.showMsgWrap(true);
        this.setMeetingStateText(t('会议已取消'));
        this.disableJoinButton();
        break;
      case MEETING_STATE.DELETED: // 已删除 3
        this.showMsgWrap(true);
        this.setMeetingStateText(t('会议已结束'));
        this.disableJoinButton();
        break;
      case MEETING_STATE.ENDED: // 无状态(过了预定结束时间，会议中无人) 6
        this.showMsgWrap(false);
        this.setMeetingStateText('');
        break;
      case MEETING_STATE.RECYCLED: // 已回收 7
        this.showMsgWrap(true);
        this.setMeetingStateText(t('会议已失效'));
        this.disableJoinButton();
        break;
      default: // MEETING_STATE.NON_EXISTENT: 会议不存在 -1
        this.showMsgWrap(true);
        this.setMeetingStateText(t('会议号无效'));
        this.disableJoinButton();
    }
  },
  handleWindowsWechat(show) {
    const windowsWechatEl = document.getElementById('windows-wechat-ctrl-pmi');
    if (show) {
      windowsWechatEl.style.display = 'block';
    } else {
      windowsWechatEl.style.display = 'none';
    }
  },
  disableJoinButton() {
    document.getElementById('joinBtnCtrl').setAttribute('disabled', '');
  },
  getSdkAppid() {
    const sdkappid = getRequest('sdkappid');
    if (typeof sdkappid === 'string') {
      return Number(sdkappid);
    }
    return Number(getSdkAppIdByEvnNum(this.envTest));
  },
  getPlatform() {
    let res = 'Android';
    const osName = getOsName();
    if (osName === 'ios') {
      res = 'iOS';
    } else if (osName === 'android') {
      res = 'Android';
    }
    return res;
  },
  dealAppCommonConfig(obj) {
    console.log('>>> dealAppCommonConfig:', obj);
    if (obj && obj.config) {
      let item = {};
      for (let i = 0; i < obj.config.length; i++) {
        if (obj.config[i].id === 'ui') {
          item = obj.config[i];
          break;
        }
      }
      console.log('>>> config item:', item);
      if (item.content && item.content.one_dial) {
        const oneDial = item.content.one_dial;
        console.log('>>> oneDial:', oneDial);
        if (oneDial.default_area && oneDial[oneDial.default_area]) {
          const defaultAreaInfo = oneDial[oneDial.default_area];
          console.log('>>> defaultAreaInfo:', defaultAreaInfo);
          this.defaultAreaInfo = defaultAreaInfo;
        }
      }
    }
  },
  getAppCommonConfig() {
    $http.get({
      url: 'v2/config/app-common-config',
      data: {
        platform: this.getPlatform(),
      },
      response: (res) => {
        console.log('>>> res:', res);
        if (res.content) {
          const tmp = atou(res.content);
          try {
            const obj = JSON.parse(tmp);
            this.dealAppCommonConfig(obj);
          } catch (err) {
            console.error(err);
          }
        }
      },
    }).catch((err) => {
      console.log(err);
    });
  },
  reportCMS(loadDuration) {
    try {
      $http.get({
        url: './cms_report/nv.cgi',
        data: {
          __data_source_id: '220000488',
          loadDuration,
        },
        response: () => {
        },
      }).catch((err) => {
        console.log('reportCMS 111 error:', err);
      });
    } catch (err) {
      console.log('reportCMS 222 error:', err);
    }
  },

  queryPmiMeetingInfo(randString, ticket) {
    const reqUrl = `${getTapiPrefix()}wemeet-tapi/wemeet/manage_service_not_auth/personal/v1/query_pmi_meeting_info`;
    let reqData;
    if (randString && ticket) {
      reqData = {
        pmi_code: this.pmiCode,
        ticket,
        rand_string: randString,
        scene: 'share',
      };
    } else {
      reqData = {
        pmi_code: this.pmiCode,
        ticket: '',
        rand_string: '',
      };
    }
    const startQueryTime = new Date().getTime() - window.$loadStartTime;
    let startQueryTimePA = null;
    if (typeof performance === 'object') {
      startQueryTimePA = performance.now();
    }
    // 有密码会议进行提示的div元素
    const passwordTipElement = document.getElementById('passwordTip');
    console.log('DPP: start queryMeetingSimpleInfo:', startQueryTime, ', :', startQueryTimePA);
    $http.post({
      url: reqUrl,
      data: reqData,
      response: (res) => {
        const loadDuration = (new Date().getTime()) - window.$loadStartTime;
        let loadDurationPa = null;
        if (typeof performance === 'object') {
          loadDurationPa = performance.now();
        }
        console.log('DPP: load_duration:', loadDuration, ', :', loadDurationPa);
        this.closePageLoading();
        beaconReport('finish_load_detail_page', {
          meeting_code: this.meetingCode,
          meeting_state: this.meetingState,
          user_agent: navigator.userAgent,
          is_launching_app: isLaunchingApp(),
          load_duration: loadDuration,
          start_query: startQueryTime,
          load_duration_pa: loadDurationPa,
          start_query_pa: startQueryTimePA,
          is_pmi: 1, // 是否是PMI会议，1：是
          is_show_applet: res && res.meeting_simple_info && res.meeting_simple_info.is_show_applet ? 1 : 0,
          pagelanguage: getUserLangForReport(),
        });

        let qrSrc = '/static/imgs/detail/qrcode.jpg';
        if (typeof res === 'object' && res.code === 0 && res.meeting_simple_info) {
          const obj = res.meeting_simple_info;
          this.resData = obj;
          this.meetingCode = obj.meeting_code;
          if (typeof obj.qr_url === 'string' && obj.qr_url.length) {
            let tmpUrl = obj.qr_url.split('://')[1];
            if (!tmpUrl) { // 不是以 https:// 或 http:// 开头
              tmpUrl = obj.qr_url;
            }
            qrSrc = `https://${tmpUrl}`;
          } else {
            window.$util.Raven('tm-Fatal: meeting detail mp qr_url EMPTY', { result: res, reqUrl, reqData });
          }

          // 拿到会议用户id去获取用户pstn信息
          if (IS_I18N) {
            this.getUserPstn({
              user_id: obj.creator_uid,
              lang: 'en',
            })
              .then((userPstnRes) => {
                if (userPstnRes.code !== 0) {
                  const handleError = (res) => {
                    if (typeof res === 'object') {
                      Toast(res.message || res.code_msg);
                    } else {
                      console.log('res is null.');
                    }
                  };

                  handleError(userPstnRes);
                  this.closePageLoading();
                  return;
                }
                this.userPstnInfo = userPstnRes.data.pstn_info;
                this.fillTelMeetingModalHtml('pmiPageDetail', this.userPstnInfo);
                this.closePageLoading();
              })
              .catch(() => {
                this.closePageLoading();
              });
          }

          if (qrSrc) {
            qrcodeImg.el.src = qrSrc; // 小程序二维码 url - 改为 dialog 弹框小程序二维码
          }
          document.getElementById('qrcodeDialogImgCtrl').src = qrSrc; // dialog 弹框小程序二维码
          this.url = atou(obj.url);
          this.setPmiMeetingThemeAndCodeAndAvatar(obj);
          this.meetingState = Number(obj.meeting_state);
          console.log('>>> obj.meeting_state:', obj.meeting_state, this.meetingState);
          this.dealMeetingState(this.meetingState);
        } else {
          if (res.code === -51009 || res.code === -51010) { // 账号需要图形验证码验证 - 请进行验证码验证
            // eslint-disable-next-line no-undef
            const captcha1 = new TencentCaptcha('2099486352', ((res) => {
              console.log('防水墙callback, res:', res);
              // 如果用户主动关闭防火墙，当作会议已失效处理
              if (res.ret === 2) {
                window.pmiPageDetail.dealMeetingState(MEETING_STATE.RECYCLED);
              }
              if (res.randstr === '' && res.ticket === '') {
                return;
              }
              window.pmiPageDetail.queryPmiMeetingInfo(
                res.randstr,
                res.ticket,
              );
            }));
            captcha1.show();
          }
          window.$util.Raven('tm-Fatal: meeting detail response not succ', { result: res, reqUrl, reqData });
          /**
           * 如果小于center会议相关base错误码：<-1000000
           */
          if (res.code < -1000000) {
            this.dealMeetingState();
          } else {
            if (typeof res === 'object') {
              Toast(res.message || res.msg);
            } else {
              console.log('res is null.');
            }
          }
        }

        if (this.joinMode === 1) { // 无中间页，直接拉起加入会议
          this.onClickJoinMeetingButton();
        }

        // 所有端判断当前会议是否为有密码，有密码才展示锁图标和加入会议按钮下方的提示文字
        if (!this.resData.has_password) {
          document.getElementById('tm-pmi-meeting-code-lock-icon-container').style.display = 'none';
          passwordTipElement.style.display = 'none';
        } else {
          document.getElementById('tm-pmi-meeting-code-lock-icon-container').style.display = 'inline-block';
          passwordTipElement.style.display = 'block';
        }
        if (this.resData) {
          if (!IS_I18N) {
            showMiniProgramButton(this.resData.is_show_applet
              && (!this.resData.media_set_type || this.resData.media_set_type === 0), true);
          }
          // subpage 利用腾讯会议域名在微信中拉起 app
          const queryObj = getQueryObject();
          const isSubpage = queryObj.subpage === 'launch';
          const pmiCode = window.pmiPageDetail.resData.pmi_code;
          if (IS_I18N && isSubpage && pmiCode) {
            window.pmiPageDetail.hideWxDetailPage();
            this.onClickJoinMeetingButton();
          }
          this.setCardContainerHeightByWidth(this.resData.is_show_applet);
        }
        // 移动端是否展示“电话入会”按钮 - telJoinBtnCtrl
        this.showTelJoinWrap();

        if (isMobile() && !isiPad()) {
          // 将主要区域（入会和拨号按钮以及二维码）居中显示（如果有足够的空白位置）
          // 如果当前没有密码，下面进行提示的这句话不显示
          if (!this.resData.has_password) {
            document.getElementById('passwordTip').style.display = 'none';
          }
        }
        this.preGetCopyMeetingInfo();
      },
    }).catch((err) => {
      this.closePageLoading();
      window.$util.Raven('tm-Fatal: meeting detail request exception!', { err, reqUrl, reqData });
      console.log(err);
    });
  },
  /**
   * 根据卡片的宽度设置卡片的高度
   */
  setCardContainerHeightByWidth(showMiniProgram) {
    const pmiMeetingInfoAndJoinMeetingContainer = document.getElementById('tm-pmi-meeting-info-and-join-meeting-container');
    const meetingInfoContainerElement = document.getElementById('tm-meeting-info-container');
    const meetingInfoContainerElementWidth = meetingInfoContainerElement.offsetWidth;
    const mainButtonsContainer = document.getElementById('mainButtons');
    meetingInfoContainerElement.style.height = `${meetingInfoContainerElementWidth}px`;
    let meetingInfoContainerElementHeight = '';
    if (showMiniProgram) {
      if (isIOS()) {
        // 判断是否为iphone 5s，有单独的设计稿
        if (screen.width === 320 && screen.height === 568) {
          meetingInfoContainerElementHeight = `${meetingInfoContainerElementWidth + 178}px`;
          mainButtonsContainer.style.bottom = 'unset';
          mainButtonsContainer.style.marginTop = '8px';
          return false;
        }
      }
      meetingInfoContainerElementHeight = `${meetingInfoContainerElementWidth + 202}px`;
    } else {
      meetingInfoContainerElementHeight = `${meetingInfoContainerElementWidth + 176}px`;
      pmiMeetingInfoAndJoinMeetingContainer.style.minHeight = 'unset';
    }
    pmiMeetingInfoAndJoinMeetingContainer.style.height = meetingInfoContainerElementHeight;
  },

  /**
   * 设置PMI会议主题和会议号码
   * @param data
   */
  setPmiMeetingThemeAndCodeAndAvatar($data) {
    const data = $data;

    const themeElement = document.getElementById('tm-pmi-meeting-theme');
    const codeElement = document.getElementById('tm-pmi-meeting-code');
    const avatarElement = document.getElementById('tm-meeting-info-container');
    const shadowElement = document.getElementById('tm-pmi-meeting-info-shadow-container');
    const limitElement = document.getElementById('tm-pmi-meeting-limit');
    themeElement.innerText = atou(data.subject);
    /**
     * 超过两行有不同的样式
     */
    if (themeElement.clientHeight > 24) {
      {
        shadowElement.style.height = '104px';
      }
    }
    codeElement.innerText = divideNum(this.pmiCode);
    const canvasWidth = 334;
    data.avatar_url = handleAvatar({
      username: atou(data.creator_nickname) || data.creator_uid,
      avatar: data.avatar_url,
      isDefaultAvatar: data.is_default_avatar,
      canvasWidth,
      canvasHeight: canvasWidth,
      fsize: 150,
      from: 'pmi-detail',
      // 设置字体的位置
      fillTextX: 167,
      fillTextY: 140,
    });
    avatarElement.style.backgroundImage = `url(${data.avatar_url})`;

    // pmi会议号是否为靓号
    if (String(data.is_beautiful_number) === '1') {
      beaconReport('H5_invitedpage_null_null_null_null_explore', { is_xlpmi: '1' });
      limitElement.style.display = 'inline-block';
    } else {
      beaconReport('H5_invitedpage_null_null_null_null_explore', { is_xlpmi: '0' });
      limitElement.style.display = 'none';
    }
  },
  closeQrcodeDialog1(idx) {
    if (idx === 2) { // 2 - 电话入会弹框
      const telEntryDialogCtrlEl = document.getElementById('telEntryDialogCtrl');
      if (telEntryDialogCtrlEl) {
        telEntryDialogCtrlEl.style.display = 'none';
      }
    } else if (idx === 3) { // 移动端电话入会弹框
      const mQrcodeDialogEl = document.getElementById('mQrcodeDialog');
      if (mQrcodeDialogEl) {
        mQrcodeDialogEl.style.display = 'none';
      }
    } else { // 1 - // 2 - 电话入会弹框
      window.pmiPageDetail.qrcodeDialogEl.style.display = 'none';
    }
  },
  closeQrcodeDialog2() {
    const qrcodeDialogCtrl2El = document.getElementById('qrcodeDialogCtrl2');
    if (qrcodeDialogCtrl2El) {
      qrcodeDialogCtrl2El.style.display = 'none';
    }
  },
  doPerformanceReport() {
    if (typeof performance !== 'object') {
      return;
    }
    const entry = performance.getEntriesByType('navigation')[0];
    if (typeof entry !== 'object') {
      return;
    }

    // console.table(entry.toJSON());

    beaconReport('detail_page_perfanalyse', {
      duration: entry.duration,
      fetch_start: entry.fetchStart,
      domain_lookup_start: entry.domainLookupStart,
      domain_lookup_end: entry.domainLookupEnd,
      connect_start: entry.connectStart,
      connect_end: entry.connectEnd,
      request_start: entry.requestStart,
      response_start: entry.responseStart,
      response_end: entry.responseEnd,
      dom_interactive: entry.domInteractive,
      dom_content_loaded_event_start: entry.domContentLoadedEventStart,
      dom_content_loaded_event_end: entry.domContentLoadedEventEnd,
      dom_complete: entry.domComplete,
      load_event_start: entry.loadEventStart,
      load_event_end: entry.loadEventEnd,
      is_pmi: 1, // 是否是PMI会议，1：是
    });
  },

  /**
   * 加载时候根据是否是跳转过来的进行曝光
  */
  loadBeaconReport() {
    const originLocation = getRequest('originOverseas');
    if (Number(originLocation) === 1) {
      return beaconReport('web_invitedpage_null_null_null_tencentmeetinginvitedpage_explore', {});
    } if (Number(originLocation) === 0) {
      return beaconReport('web_invitedpage_null_null_null_voovinvitedpage_explore', {});
    }
  },
};

const init = async () => {
  // pmi和voov互相跳转逻辑
  // const willJump = await jumpByCountryWithCookie(JUMP_TYPE.PMI);
  // if (willJump && !isWxwork()) {
  //   window.location.href = willJump;
  //   return;
  // }
  window.pmiPageDetail.ifSupportWebp();
  // 设置默认语言
  window.pmiPageDetail.setDefLanguage();
  // 根据IP地址获取对应地区
  window.pmiPageDetail.getIpLocation();

  if (isMobile() && !isiPad() && isWxwork() && !IS_I18N) {
    showMiniProgramButton(false, true);
  }

  window.resizeContentCtrl();
  window.addEventListener('resize', () => {
    window.resizeContentCtrl();
  }, false);
  // visit_detail_page 访问页面 和 finish_load_detail_page 页面加载完成
  beaconReport('visit_detail_page', {
    meeting_code: window.pmiPageDetail.meetingCode,
    meeting_state: window.pmiPageDetail.meetingState,
    user_agent: navigator.userAgent,
    is_launching_app: isLaunchingApp(),
    is_pmi: 1, // 是否是PMI会议，1：是
    wemeet_platform: getOsName(),
  });
  if (!window.pmiPageDetail.pmiCode) {
    Toast(t('参数错误'), 5000);
    return false;
  }
  window.pmiPageDetail.queryPmiMeetingInfo();
  // 二维码
  if (isMobile()) {
    qrcodeImg.el.addEventListener('touchstart', qrcodeImg.handleTouchstart, false);
    qrcodeImg.el.addEventListener('touchend', qrcodeImg.handleTouchend, false);
  } else {
    qrcodeImg.el.addEventListener('mousedown', qrcodeImg.handleMousedown, false);
    qrcodeImg.el.addEventListener('mouseup', qrcodeImg.handleMouseup, false);
  }
  window.pmiPageDetail.initPmiInfoDirection();
};

init();

let $perfnow = null;
if (typeof performance === 'object') {
  $perfnow = performance.now();
}
console.log('DPP: adding window.onload, :', $perfnow);

window.onload = () => {
  let $perfnow = null;
  if (typeof performance === 'object') {
    $perfnow = performance.now();
  }
  console.log('DPP: window.onload, :', $perfnow);
  const qobj = getQueryObject();
  if (qobj.debugMode === '1') {
    window.debugMode = true;
  }
  if (isMobile() && !isFormalEnv()) {
    // will only load when not in formal env
    loadVConsoleScript(loadScript);
  } else if (window.debugMode) {
    loadVConsoleScript(loadScript);
  }

  // load tcss

  (function () {
    let node = document.createElement('script');
    const script = document.getElementsByTagName('script')[0];
    node.src = 'https://pingjs.qq.com/tcss.ping.https.js';
    node.type = 'text/javascript';
    node.onload = function () {
      /loaded|complete|undefined/.test(node.readyState) && (function () {
        if (typeof (pgvMain) === 'function') {
          if (location.host === 'meeting.qq.com' || location.host === 'meeting.tencent.com' || location.host === 'wemeet.qq.com') {
            window.pgvMain({ virtualDomain: 'meeting.qq.com' });
          }
        }
        node.onload = null;
        node.onerror = null;
        node.onreadystatechange = null;
        node.parentNode.removeChild(node);
        node = undefined;
      }());
    };
    node.onerror = node.onload;
    node.onreadystatechange = node.onload;
    script.parentNode.insertBefore(node, script);
  }());

  window.pmiPageDetail.loadBeaconReport();

  setDefaultLocal();
};

window.isNewProject = () => alert('yes');
